import type { OperationDefinition, FeatureRegistration } from './types';

const features = new Map<string, FeatureRegistration>();
const operations = new Map<string, OperationDefinition>();

export function registerFeature(registration: FeatureRegistration): void {
  features.set(registration.name, registration);
  for (const op of registration.operations) {
    if (operations.has(op.type)) {
      throw new Error(`Operation type "${op.type}" is already registered`);
    }
    operations.set(op.type, op);
  }
}

export function getOperation(type: string): OperationDefinition {
  const op = operations.get(type);
  if (!op) {
    throw new Error(`Unknown operation type: "${type}"`);
  }
  return op;
}

export function getAllFeatures(): FeatureRegistration[] {
  return Array.from(features.values());
}
